// src/components/icon-button.ts
import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'

@customElement('icon-button')
export class IconButton extends LitElement {
    @property({ type: String }) ariaLabel = 'Button'

    static styles = css`
        :host {
            display: inline-block;
        }

        button {
            background: none;
            border: none;
            cursor: pointer;
            padding: var(--s-1);
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            transition: background-color var(--transition-fast, 0.15s);
            width: var(--control-height);
            height: var(--control-height);
        }

        button:hover {
            background-color: var(--color-bg-tertiary);
        }

        ::slotted(svg) {
            width: 100%;
            height: 100%;
            fill: var(--primary-color);
        }
    `

    render() {
        return html`
            <button aria-label="${this.ariaLabel}">
                <slot></slot>
            </button>
        `
    }
}
